import { withTheme } from 'styled-components'

export const HeaderIconSuccess = withTheme((props) => (
	<svg {...props} width='121' height='128' viewBox='0 0 121 128' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M60.5 128C93.9132 128 121 100.733 121 67.0968C121 33.4609 93.9132 6.1936 60.5 6.1936C27.0868 6.1936 0 33.4609 0 67.0968C0 100.733 27.0868 128 60.5 128Z'
			fill='#005E5D'
		/>
		<mask
			id='mask0_959_118602'
			style={{ maskType: 'alpha' }}
			maskUnits='userSpaceOnUse'
			x='0'
			y='0'
			width='121'
			height='128'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M121 0H0V66.6016V83.252H2.25107C9.40246 109.071 32.773 128 60.5 128C88.227 128 111.598 109.071 118.749 83.252H121V66.6016V0Z'
				fill='white'
			/>
		</mask>
		<g mask='url(#mask0_959_118602)'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M86.5103 0.447722C89.3161 0.0788691 92.2974 1.2335 94.4967 3.00976C96.696 4.78601 97.9222 7.02952 98.1566 9.85385L108.237 155.59C108.611 161.62 104.046 166.831 98.0293 167.243L28.395 172.228C22.3805 172.678 17.1514 168.167 16.7023 162.143L6.816 16.9534C6.44164 10.9235 10.859 5.84437 16.876 5.43256L86.5103 0.447722Z'
				fill='url(#paint0_linear_959_118602)'
				fillOpacity='0.5'
			/>
			<path
				d='M15.1084 12C15.1084 6.47715 19.5855 2 25.1084 2H95.8918C101.415 2 105.892 6.47715 105.892 12V159.355C105.892 164.878 101.415 169.355 95.8917 169.355H25.1084C19.5855 169.355 15.1084 164.878 15.1084 159.355V12Z'
				fill='url(#paint1_linear_959_118602)'
				stroke='#004C4C'
				strokeWidth='4'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M48.3999 14.4517C48.3999 13.3115 49.3242 12.3872 50.4644 12.3872H70.5354C71.6756 12.3872 72.5999 13.3115 72.5999 14.4517C72.5999 15.5919 71.6756 16.5162 70.5354 16.5162H50.4644C49.3242 16.5162 48.3999 15.5919 48.3999 14.4517Z'
				fill='#004C4C'
			/>
			<mask
				id='mask1_959_118602'
				style={{ maskType: 'alpha' }}
				maskUnits='userSpaceOnUse'
				x='13'
				y='0'
				width='95'
				height='172'
			>
				<path
					d='M15.1084 12C15.1084 6.47715 19.5855 2 25.1084 2H95.8918C101.415 2 105.892 6.47715 105.892 12V159.355C105.892 164.878 101.415 169.355 95.8917 169.355H25.1084C19.5855 169.355 15.1084 164.878 15.1084 159.355V12Z'
					fill='url(#paint2_linear_959_118602)'
					stroke='#004C4C'
					strokeWidth='4'
				/>
			</mask>
			<g mask='url(#mask1_959_118602)'>
				<path
					opacity='0.3'
					fillRule='evenodd'
					clipRule='evenodd'
					d='M107.892 0L13.1084 172.387V0H107.892Z'
					fill='#808080'
				/>
			</g>
		</g>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M58.2372 98.0641C72.7162 98.0641 84.4538 86.048 84.4538 71.2254C84.4538 56.4028 72.7162 44.3867 58.2372 44.3867C43.7581 44.3867 32.0205 56.4028 32.0205 71.2254C32.0205 86.048 43.7581 98.0641 58.2372 98.0641Z'
			fill='#005E5D'
			fillOpacity='0.3'
		/>
		<path
			d='M61.2621 94.9675C75.7411 94.9675 87.4787 82.9514 87.4787 68.1288C87.4787 53.3061 75.7411 41.29 61.2621 41.29C46.783 41.29 35.0454 53.3061 35.0454 68.1288C35.0454 82.9514 46.783 94.9675 61.2621 94.9675Z'
			fill='white'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M60.5319 77.2625L75.7545 61.5979C76.5981 60.7292 76.5981 59.3231 75.7545 58.4543C74.9088 57.5901 73.5399 57.5901 72.6985 58.4543L57.4759 74.1211L49.8292 66.2523C48.9812 65.388 47.6145 65.388 46.7732 66.2523C45.9252 67.1188 45.9252 68.5249 46.7732 69.3958L54.4221 77.2625L55.9479 78.832C56.7937 79.7008 58.1604 79.7008 59.0039 78.832L60.5319 77.2625Z'
			fill='#528217'
		/>
		<defs>
			<linearGradient
				id='paint0_linear_959_118602'
				x1='-15.4532'
				y1='85.9027'
				x2='97.9967'
				y2='136.215'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopOpacity='0.13' />
				<stop offset='1' stopOpacity='0.28' />
			</linearGradient>
			<linearGradient
				id='paint1_linear_959_118602'
				x1='62.5314'
				y1='-58.0415'
				x2='-42.4779'
				y2='6.97034'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopColor='#00C5BC' />
				<stop offset='1' stopColor='#009286' />
			</linearGradient>
			<linearGradient
				id='paint2_linear_959_118602'
				x1='62.5314'
				y1='-58.0415'
				x2='-42.4779'
				y2='6.97034'
				gradientUnits='userSpaceOnUse'
			>
				<stop stopColor='#00C5BC' />
				<stop offset='1' stopColor='#009286' />
			</linearGradient>
		</defs>
	</svg>
))
